import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const FormatBold = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M16.575 17.184h-4.803v5.548h4.686c1.768 0 3.682-0.618 3.682-2.647 0-2.14-1.56-2.9-3.565-2.9zM16.458 9.127h-4.686v5.014h4.773c1.71 0 3.153-0.59 3.153-2.477 0-1.916-1.53-2.536-3.24-2.536zM21.878 24.648c-1.618 1.182-3.564 1.352-5.568 1.352h-7.37c-0.52 0-0.94-0.407-0.94-0.91v-18.18c0-0.502 0.42-0.91 0.94-0.91h7.37c1.68 0 3.418 0.226 4.832 1.1 1.533 0.957 2.416 2.62 2.416 4.337 0 1.634-0.795 3.466-2.563 4.226 1.975 0.873 3.005 2.647 3.005 4.507 0 1.774-0.618 3.38-2.12 4.478z" />
  </SvgIcon>
);

export default FormatBold;
